module.exports = __webpack_public_path__ + "static/Unify-3-light-fe2a2abf7afd3115d425da2e1c9575bc.svg";